module.exports = __webpack_public_path__ + "static/img/12.620a44d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/12.png
// module id = g8vI
// module chunks = 0